import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TransferCodeConfirmationComponent } from './transfer-code-confirmation.component';
import { CountdownPipe } from 'src/app/pipe/countdown.pipe';
import { CountdownPipeModule } from 'src/app/pipe/pipe.module';

@NgModule({
  declarations: [TransferCodeConfirmationComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CountdownPipeModule
  ],
  exports: [TransferCodeConfirmationComponent]
})
export class TransferCodeConfirmationModule {}
